export const name: string = 'Data Edit Dialog';
export const moduleName: string = 'pdc-widget-data-edit-dialog';
export const icon: string = 'edit';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'pdc-widget-data-edit-dialog'; //Theme ID (to SELECT and EXPAND it in Theme dialog)

export const themeFields = {
    autoApplyMode: 'widget-data-edit-dialog-auto-apply-mode',
    titlePosition: 'widget-data-edit-dialog-title-position',
    titleWidth: 'widget-data-edit-dialog-title-width',
    verticalSpacing: 'widget-data-edit-dialog-vertical-spacing',
    applyButtonTitle: 'widget-data-edit-dialog-apply-button-title',
    hideCancelButton: 'widget-data-edit-dialog-hide-cancel-button',
    hideApplyButton: 'widget-data-edit-dialog-hide-apply-button'
};
